module.exports = __webpack_public_path__ + "img/DSC131-min.eff1a12f.png";